import React, { useEffect, useState } from 'react';
export function Countdown() {
  // Set to 2 hours from now
  const [timeLeft, setTimeLeft] = useState(2 * 60 * 60 + 15 * 60 + 30); // 2h 15m 30s
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <div className="flex flex-col items-center justify-center my-6" data-id="element-197">
      <p className="text-red-600 font-bold mb-2 text-sm uppercase tracking-wider animate-pulse" data-id="element-198">
        ⚠️ La oferta termina en:
      </p>
      <div className="flex gap-3" data-id="element-199">
        <div className="flex flex-col items-center" data-id="element-200">
          <div className="bg-red-600 text-white font-bold text-2xl w-12 h-12 flex items-center justify-center rounded shadow-lg" data-id="element-201">
            {hours.toString().padStart(2, '0')}
          </div>
          <span className="text-xs text-gray-500 mt-1 font-medium" data-id="element-202">HORAS</span>
        </div>
        <div className="text-red-600 font-bold text-2xl mt-2" data-id="element-203">:</div>
        <div className="flex flex-col items-center" data-id="element-204">
          <div className="bg-red-600 text-white font-bold text-2xl w-12 h-12 flex items-center justify-center rounded shadow-lg" data-id="element-205">
            {minutes.toString().padStart(2, '0')}
          </div>
          <span className="text-xs text-gray-500 mt-1 font-medium" data-id="element-206">MIN</span>
        </div>
        <div className="text-red-600 font-bold text-2xl mt-2" data-id="element-207">:</div>
        <div className="flex flex-col items-center" data-id="element-208">
          <div className="bg-red-600 text-white font-bold text-2xl w-12 h-12 flex items-center justify-center rounded shadow-lg" data-id="element-209">
            {seconds.toString().padStart(2, '0')}
          </div>
          <span className="text-xs text-gray-500 mt-1 font-medium" data-id="element-210">SEG</span>
        </div>
      </div>
    </div>;
}